import React, { useState } from 'react';
import api from '../utils/api';
import Reveal from '../components/common/Reveal';
import { SocialBar } from '../components/common/SocialIcons';
import { SectionHeader, BtnPrimary, Card, FormGroup, inputStyle } from '../components/ui';
import { WHATSAPP_LINK, WHATSAPP_DISPLAY, SOCIAL } from '../utils/constants';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!form.name || !form.message) return;
    try { await api.post('/contacts', form); setSent(true); } catch {}
  };

  return (
    <div>
      <div style={{ padding: '120px 40px 40px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <SectionHeader title="Get in" accent="Touch" sub="We'd love to hear from you" />
      </div>
      <section style={{ padding: '40px 40px 80px', maxWidth: 800, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 24 }}>
          <Reveal><Card style={{ padding: 28 }}>
            <h3 className="serif" style={{ fontSize: '1.3rem', marginBottom: 20 }}>Contact Info</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <div><p style={{ fontSize: 13, color: '#999', marginBottom: 4 }}>WhatsApp / Phone</p><a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--saffron-dark)', fontWeight: 700, fontSize: '1.2rem' }}>{WHATSAPP_DISPLAY}</a></div>
              <div><p style={{ fontSize: 13, color: '#999', marginBottom: 8 }}>Follow Us</p><SocialBar /></div>
              <div><p style={{ fontSize: 13, color: '#999', marginBottom: 4 }}>YouTube</p><a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--saffron-dark)', fontWeight: 500, fontSize: 14 }}>Wijjdan Channel</a></div>
            </div>
          </Card></Reveal>
          <Reveal delay={.1}><Card style={{ padding: 28 }}>
            {sent ? (
              <div style={{ textAlign: 'center', padding: 20 }}><div style={{ fontSize: 44, marginBottom: 12 }}>📨</div><p style={{ fontWeight: 500 }}>Message sent! We'll get back to you soon.</p></div>
            ) : (
              <>
                <FormGroup label="Name *"><input style={inputStyle} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" /></FormGroup>
                <FormGroup label="Email"><input type="email" style={inputStyle} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="your@email.com" /></FormGroup>
                <FormGroup label="Message *"><textarea style={{ ...inputStyle, minHeight: 120, resize: 'vertical' }} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Your message..." /></FormGroup>
                <BtnPrimary onClick={submit} style={{ width: '100%', justifyContent: 'center' }}>Send Message</BtnPrimary>
              </>
            )}
          </Card></Reveal>
        </div>
      </section>
    </div>
  );
}
